import _ from 'lodash';
import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from '@/features/card-account/screens/create-card-account/type';

import { SelectCardAccountWebScreen } from '@/features/card-account/screens/create-card-account/SelectCardAccountWeb.screen';
import { SelectCardAccountNativeScreen } from '@/features/card-account/screens/create-card-account/SelectCardAccountNative.screen';

export interface SelectCardAccountScreenProps {}

export const SelectCardAccountScreen: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.SelectCardAccount>> = ({
  navigation,
  route
}) => {
  const layout = useContext(LayoutContext);
  const { onLayout, onSelect, onChangeView, borderRadiusFlag } = route.params;

  if (layout.isMobile) {
    return <SelectCardAccountNativeScreen onSelect={onSelect} />;
  }
  return (
    <SelectCardAccountWebScreen onLayout={onLayout} onSelect={onSelect} onChangeView={onChangeView} borderRadiusFlag={borderRadiusFlag} />
  );
};
